import { CheckCircleOutline, ErrorOutline } from "@mui/icons-material";
import { Modal, Box, Typography, CircularProgress } from "@mui/material";
import { useState, forwardRef, useImperativeHandle } from "react";

import { ValidateCustomerModalStyled } from "../styles";
import { filterLinksStabilityModal } from "./constants";
import { CheckResult, StabilityCheckModalProps } from "./types";

const StabilityCheckModal = forwardRef(
    (props: StabilityCheckModalProps, ref) => {
        const [open, setOpen] = useState(false);
        const [checking, setChecking] = useState(false);
        const [checkResults, setCheckResults] = useState<CheckResult[]>([]);

        const performStabilityChecks = async () => {
            setChecking(true);
            const checks = filterLinksStabilityModal(
                props?.modulesCustomer || [],
                props?.customerName || ""
            );

            if (!checks.length) {
                setCheckResults([]);
                setChecking(false);
                return;
            }

            const results = await Promise.all(
                checks.map(async (check) => {
                    try {
                        await fetch(check.url, { mode: "no-cors" });
                        // const statusCheck = res.status === check.expectedStatus;
                        // const bodyCheck = true;

                        const body = null;

                        // if (check.expectedBody) {
                        //     body = await res?.text();
                        //     bodyCheck = body?.includes(check.expectedBody);
                        // }
                        return {
                            url: check.url,
                            success: true,
                            body,
                        };
                    } catch (error) {
                        return {
                            url: check.url,
                            success: false,
                            error,
                            body: JSON.stringify(error),
                        };
                    }
                })
            );

            setCheckResults(results);
            setChecking(false);
        };

        useImperativeHandle(ref, () => ({
            openModal: () => {
                setOpen(true);
                performStabilityChecks();
            },
        }));

        const handleClose = () => {
            setOpen(false);
            setCheckResults([]);
        };

        return (
            <Modal open={open} onClose={handleClose}>
                <ValidateCustomerModalStyled>
                    <Typography variant="h6">
                        Verificando a estabilidade do sistema...
                    </Typography>
                    {checking ? (
                        <CircularProgress />
                    ) : (
                        checkResults.map((result: CheckResult) => (
                            <Box
                                key={result.url}
                                display="flex"
                                alignItems="center"
                                justifyContent="flex-start"
                                width="100%"
                                mb={1}
                            >
                                {result?.success ? (
                                    <CheckCircleOutline color="success" />
                                ) : (
                                    <ErrorOutline color="error" />
                                )}
                                <Typography variant="body1" sx={{ ml: 1 }}>
                                    {result?.url}
                                </Typography>
                            </Box>
                        ))
                    )}
                </ValidateCustomerModalStyled>
            </Modal>
        );
    }
);

export default StabilityCheckModal;
